import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PETITION_PAGE_AI_SUMMARY_CARDS = defineFcm('petition_page_ai_summary_cards')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experiment_name: {
					type: 'string',
					description:
						'The name of the experiment to use for the AI summary cards presentation on the Petition Details page.',
				},
				enabled: {
					type: 'boolean',
					default: false,
					description: 'Whether the AI summary cards (v2) presentation is enabled on the Petition Details page.',
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-vaquita',
		scope: 'corgi-middle-end',
		context: 'Petition Details page',
		description: 'Controls whether the AI summary cards (v2) presentation is enabled on the Petition Details page.',
		import: false,
		template: {
			enabled: false,
			experiment_name: 'petition_page_ai_summary_cards_experiment',
		},
	});
